import { Itin } from 'src/app/core/itinerari/itinerari.model';
import { first, tap } from 'rxjs/operators';
import { Poi } from 'src/app/core/poi/poi.model';
import { Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Languages {
  it?: string;
  en?: string;
  sl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CrudAlertService {
  name = '';
  address = '';
  shortDescr = '';
  description = '';
  coordsLat = '';
  coordsLon = '';
  geopos = '';
  pois = '';

  constructor(private translate: TranslateService) {
    this.changeLangFunction();
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  private changeLangFunction() {
    this.translate.get([
      'new_poi.sections.name',
      'new_poi.sections.address',
      'new_poi.sections.coords.lat',
      'new_poi.sections.coords.lon',
      'new_poi.sections.short_descr',
      'new_poi.sections.descr',
      'admin_single_itin.sections.geopos',
      'new_itin.sections.pois'
    ]).pipe(
      first(),
      tap((response: any) => {
        this.name = response['new_poi.sections.name'];
        this.address = response['new_poi.sections.address'];
        this.coordsLat = response['new_poi.sections.coords.lat'];
        this.coordsLon = response['new_poi.sections.coords.lon'];
        this.shortDescr = response['new_poi.sections.short_descr'];
        this.description = response['new_poi.sections.descr'];
        this.geopos = response['admin_single_itin.sections.geopos'];
        this.pois = response['new_itin.sections.pois'];
      })
    ).subscribe();
  }

  public checkPoiValidity(poi: Poi): string[] {
    const invalidFields: string[] = [];
    invalidFields.push(this.checkLanguages(poi.poi_name, this.name));
    invalidFields.push(!poi.address ? this.address : null);
    invalidFields.push(!poi.coords?.lat ? this.coordsLat : null);
    invalidFields.push(!poi.coords?.lon ? this.coordsLon : null);
    invalidFields.push(this.checkLanguages(poi.short_descr, this.shortDescr));
    invalidFields.push(this.checkLanguages(poi.description, this.description));
    invalidFields.push(poi.geopos.length === 0 ? this.geopos : null);

    const returnInvalidFields: string[] = invalidFields.filter((stringValue) => stringValue !== null);

    return returnInvalidFields.length > 0 ? returnInvalidFields : null;
  }

  public checkItinValidity(itin: Itin): string[] {
    const invalidFields: string[] = [];
    invalidFields.push(this.checkLanguages(itin.itin_name, this.name));
    invalidFields.push(this.checkLanguages(itin.short_descr, this.shortDescr));
    invalidFields.push(this.checkLanguages(itin.description, this.description));
    invalidFields.push(itin.pois.length <= 1 ? this.pois : null);
    invalidFields.push(itin.geopos.length === 0 ? this.geopos : null);

    const returnInvalidFields: string[] = invalidFields.filter((stringValue) => stringValue !== null);

    return returnInvalidFields.length > 0 ? returnInvalidFields : null;
  }

  private checkLanguages(obj: Languages, stringValue: string): string {
    let valid = true;
    const returnValue: string[] = [];
    if (!obj.it) {
      valid = false;
      returnValue.push('Italiano');
    }
    if (!obj.sl) {
      valid = false;
      returnValue.push('Slovenščina');
    }
    if (!obj.en) {
      valid = false;
      returnValue.push('English');
    }
    return valid ? null : stringValue + ' (' + returnValue.join(', ') + ')';
  }
}
